import { useLang } from "../i18n/LangContext";
import { LegalShell, useLegal } from "./Privacy";

function Section({ title, children }) {
  return (
    <section className="space-y-2">
      <h2 className="text-base md:text-lg font-semibold text-white">{title}</h2>
      <div className="text-sm text-slate-300 leading-relaxed space-y-2">{children}</div>
    </section>
  );
}

export default function Terms() {
  const { t } = useLang();
  const legal = useLegal();
  const entity = legal.entity_name || "[Nama Usaha]";
  return (
    <LegalShell testId="terms-page" title={t("legal.termsTitle")}>
      <p className="text-sm text-slate-400">
        {t("legal.effective")}: {legal.effective_date || "—"} · {t("legal.version")} {legal.version || "1.0"}
      </p>
      <Section title={t("legal.tService")}><p>{t("legal.tServiceBody").replace("{entity}", entity)}</p></Section>
      <Section title={t("legal.tAccount")}><p>{t("legal.tAccountBody")}</p></Section>
      <Section title={t("legal.tPayment")}><p>{t("legal.tPaymentBody")}</p></Section>
      <Section title={t("legal.tContent")}><p>{t("legal.tContentBody")}</p></Section>
      <Section title={t("legal.tHealth")}><p>{t("legal.tHealthBody")}</p></Section>
      <Section title={t("legal.tCoach")}><p>{t("legal.tCoachBody")}</p></Section>
      <Section title={t("legal.tTermination")}><p>{t("legal.tTerminationBody")}</p></Section>
      <Section title={t("legal.tLaw")}>
        <p>{t("legal.tLawBody").replace("{city}", legal.city || "[Kota]").replace("{country}", legal.country || "Indonesia")}</p>
        <p>{t("legal.contact")}: {legal.contact_email || "—"}</p>
      </Section>
    </LegalShell>
  );
}
